import { put, call, takeEvery } from 'redux-saga/effects';
import * as Actions from './actions';
import * as _service from './service';
import * as Constants from './constants';
import { toast } from "react-toastify";

// Nouvelle saga pour vérifier le crédit avant de lancer la recherche
function* checkCreditAndSearchSaga(action) {
  const { searchValue, companyId } = action;

  try {
    // Étape 1: Vérifier le crédit de l'utilisateur
    const creditResponse = yield call(_service.fetchCompanyCredit, companyId);

    if (creditResponse.status === 200) {
      const creditData = creditResponse?.data;

      // Vérifier si l'utilisateur a des crédits (le premier élément du tableau)
      const accountData = Array.isArray(creditData) && creditData.length > 0
        ? creditData[0]
        : null;

      const currentCredit = accountData?.credit ?? 0;

      if (currentCredit > 0) {
        // L'utilisateur a du crédit, on lance la recherche
        yield put(Actions.checkCreditSuccess(accountData));

        // Lancer la recherche normale
        const searchResponse = yield call(_service.fetchSearch, searchValue);

        if (searchResponse.status === 200) {
          yield put(Actions.searchSuccess(searchResponse?.data?.data));
        } else {
          yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
          yield put(Actions.searchFailed(searchResponse.error));
        }
      } else {
        // Pas de crédit, on dispatch l'action pour afficher le modal
        yield put(Actions.checkCreditInsufficient(accountData));
      }
    } else {
      yield call(toast.error, "Erreur lors de la vérification du crédit.");
      yield put(Actions.checkCreditFailed(creditResponse.error));
    }
  } catch (e) {
    // En cas d'erreur de l'API de crédit, on affiche une erreur
    yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    yield put(Actions.checkCreditFailed(e));
  }
}

// Saga de recherche simple (sans vérification de crédit - pour les utilisateurs non connectés ou autres cas)
function* loadSearchSaga(searchPayload) {
  const { payload } = searchPayload
  try {
    const response = yield call(_service.fetchSearch, payload);
    if (response.status === 200) {
      yield put(Actions.searchSuccess(response?.data?.data));
    } else {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      yield put(Actions.searchFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";
    if (is429Error || isRateLimitError) {
      yield call(toast.error, "Vous avez atteint la limite de recherche gratuite. Veuillez vous connecté et recharger votre compte pour continuer recherches.");
    } else {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchFailed(e));
  }
}


function* loadSearchAlerteSaga(searchPayload) {
  const { payload } = searchPayload
  try {
    const response = yield call(_service.fetchSearchAlerte, payload);
    if (response.status === 200) {
      yield put(Actions.searchSuccess(response?.data?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchFailed(e));
  }
}

function* loadSearchDetailSaga(searchPayload) {
  const { payload } = searchPayload
  try {
    const response = yield call(_service.fetchSearchDetail, payload);
    if (response.status === 200) {
      yield put(Actions.searchDetailSuccess(response?.data?.data[0]));

      // VÉRIFIER limited_access avant d'appeler l'API dirigeants
      const detailData = response?.data?.data[0];

      // Déterminer si l'accès est limité
      let limitedAccess = false;

      if (typeof detailData?.limited_access !== 'undefined') {
        limitedAccess = detailData.limited_access;
      } else if (typeof detailData?.limited !== 'undefined') {
        limitedAccess = detailData.limited;
      } else if (typeof detailData?.has_credit !== 'undefined') {
        limitedAccess = !detailData.has_credit;
      }

      // N'appeler l'API dirigeants QUE si l'accès n'est PAS limité
      if (!limitedAccess && detailData?.dirigeants) {
        const list_dirigeants = {
          dirigeants: detailData.dirigeants
        };
        yield put(Actions.searchDirigeantsDetailRequest(list_dirigeants));
      }

    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchDetailFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchDetailFailed(e));
  }
}

//Saga pour les decisions du demandeur
function* loadSearchDecisionApplicantsSaga(decisionApplicantsPayload) {
  const { payload } = decisionApplicantsPayload
  try {
    const response = yield call(_service.fetchSearchDecision, 'recouv/decision-demandeurs', payload);
    if (response.status === 200) {
      yield put(Actions.searchDecisionApplicantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchDecisionApplicantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchDecisionApplicantsFailed(e));
  }
}

function* loadPaginateSearchDecisionApplicantsSaga(payload) {
  const { url, denomination, nom_commercial } = payload
  try {
    const response = yield call(_service.paginateFetchSearchDecision, url, denomination ?? nom_commercial);
    if (response.status === 200 || response.status === 201) {
      yield put(Actions.paginateSearchDecisionApplicantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.paginateSearchDecisionApplicantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.paginateSearchDecisionApplicantsFailed(e));
  }
}



//Saga pour les decisions du defendeur
function* loadSearchDecisionDefendantsSaga(decisionDefendantsPayload) {
  const { payload } = decisionDefendantsPayload
  try {
    const response = yield call(_service.fetchSearchDecision, 'recouv/decision-defendeurs', payload);
    if (response.status === 200) {
      yield put(Actions.searchDecisionDefendantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchDecisionDefendantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchDecisionDefendantsFailed(e));
  }
}

function* loadPaginateSearchDecisionDefendantsSaga(payload) {
  const { url, denomination, nom_commercial } = payload
  try {
    const response = yield call(_service.paginateFetchSearchDecision, url, denomination ?? nom_commercial);
    if (response.status === 200 || response.status === 201) {
      yield put(Actions.paginateSearchDecisionDefendantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.paginateSearchDecisionDefendantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.paginateSearchDecisionDefendantsFailed(e));
  }
}

//Saga pour les autres decisions du demandeur
function* loadSearchOthersApplicantsSaga(othersApplicantsPayload) {
  const { payload } = othersApplicantsPayload
  try {
    const response = yield call(_service.fetchSearchDecision, 'recouv/others-demandeurs', payload);
    if (response.status === 200) {

      yield put(Actions.searchOthersApplicantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchOthersApplicantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchOthersApplicantsFailed(e));
  }
}

function* loadPaginateSearchOthersApplicantsSaga(payload) {
  const { url, denomination, nom_commercial } = payload
  try {
    const response = yield call(_service.paginateFetchSearchDecision, url, denomination ?? nom_commercial);
    if (response.status === 200 || response.status === 201) {
      yield put(Actions.paginateSearchOthersApplicantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.paginateSearchOthersApplicantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.paginateSearchOthersApplicantsFailed(e));
  }
}

//Saga pour les autres decisions du defendeur
function* loadSearchOthersDefendantsSaga(OthersDefendantsPayload) {
  const { payload } = OthersDefendantsPayload
  try {
    const response = yield call(_service.fetchSearchDecision, 'recouv/others-defendeurs', payload);
    if (response.status === 200) {
      yield put(Actions.searchOthersDefendantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchOthersDefendantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchOthersDefendantsFailed(e));
  }
}

function* loadPaginateSearchOthersDefendantsSaga(payload) {
  const { url, denomination, nom_commercial } = payload
  try {
    const response = yield call(_service.paginateFetchSearchDecision, url, denomination ?? nom_commercial);
    if (response.status === 200 || response.status === 201) {
      yield put(Actions.paginateSearchOthersDefendantsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.paginateSearchOthersDefendantsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.paginateSearchOthersDefendantsFailed(e));
  }
}

function* loadSearchDirigeantsDetailSaga(searchPayload) {
  const { payload } = searchPayload
  try {
    const response = yield call(_service.fetchSearchDirigeantsDetail, payload);
    if (response.status === 200) {
      yield put(Actions.searchDirigeantsDetailSuccess(response?.data?.dirigeants));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchDirigeantsDetailFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchDirigeantsDetailFailed(e));
  }
}

//Saga pour les annonces légales
function* loadSearchAnnoncesSaga(annoncesPayload) {
  const { payload } = annoncesPayload;
  try {
    const response = yield call(_service.fetchSearchAnnonces, payload);
    if (response.status === 200) {
      // Stocker la réponse complète (avec count, next, previous, results)
      yield put(Actions.searchAnnoncesSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchAnnoncesFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchAnnoncesFailed(e));
  }
}

//Saga pour les marchés publics
function* loadSearchMarchesPublicsSaga(marchesPayload) {
  const { payload } = marchesPayload;
  try {
    const response = yield call(_service.fetchSearchMarchesPublics, payload);
    if (response.status === 200) {
      // Stocker la réponse complète (avec count, next, previous, results)
      yield put(Actions.searchMarchesPublicsSuccess(response?.data));
    } else {
      const is429Error = response.error?.response?.status === 429;
      const isRateLimitError = response.error?.response?.data?.message === "Limite de requêtes atteinte.";

      if (!is429Error && !isRateLimitError) {
        yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
      }
      yield put(Actions.searchMarchesPublicsFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (!is429Error && !isRateLimitError) {
      yield call(toast.error, "Une erreur s'est produite veuillez, contacter le service support.");
    }
    yield put(Actions.searchMarchesPublicsFailed(e));
  }
}

// Saga pour la pagination des annonces légales
function* loadPaginateSearchAnnoncesSaga(paginatePayload) {
  const { url } = paginatePayload;
  try {
    const response = yield call(_service.paginateFetchSearchAnnonces, url);
    if (response.status === 200) {
      yield put(Actions.paginateSearchAnnoncesSuccess(response?.data));
    } else {
      yield put(Actions.paginateSearchAnnoncesFailed(response.error));
    }
  } catch (e) {
    yield put(Actions.paginateSearchAnnoncesFailed(e));
  }
}

// Saga pour la pagination des marchés publics
function* loadPaginateSearchMarchesPublicsSaga(paginatePayload) {
  const { url } = paginatePayload;
  try {
    const response = yield call(_service.paginateFetchSearchMarchesPublics, url);
    if (response.status === 200) {
      yield put(Actions.paginateSearchMarchesPublicsSuccess(response?.data));
    } else {
      yield put(Actions.paginateSearchMarchesPublicsFailed(response.error));
    }
  } catch (e) {
    yield put(Actions.paginateSearchMarchesPublicsFailed(e));
  }
}

// Nouvelle saga pour récupérer toutes les entités liées à une entreprise en un seul appel
function* loadCompanyEntitiesSaga(payload) {
  const { payload: denomination } = payload;
  try {
    const response = yield call(_service.fetchCompanyEntities, denomination);

    if (response.status === 200) {
      // Vérifier si l'API a trouvé des données
      if (response?.data?.success === false) {
        // Aucune entreprise trouvée, afficher un message d'avertissement
        yield call(toast.warn, "Aucune information complémentaire trouvée pour cette entreprise (annonces légales, marchés publics, décisions de justice).");

        // Dispatcher des résultats vides pour toutes les entités
        yield put(Actions.searchAnnoncesSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchMarchesPublicsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchDecisionApplicantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchDecisionDefendantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchOthersApplicantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchOthersDefendantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.fetchCompanyEntitiesSuccess(response?.data));
        return;
      }

      const entities = response?.data?.entities;

      // Dispatcher les succès pour les annonces légales
      if (entities?.annonces) {
        yield put(Actions.searchAnnoncesSuccess({
          count: entities.annonces.count,
          results: entities.annonces.items || [],
          next: null,
          previous: null
        }));
      } else {
        yield put(Actions.searchAnnoncesSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));
      }

      // Dispatcher les succès pour les marchés publics
      if (entities?.marches_publics) {
        yield put(Actions.searchMarchesPublicsSuccess({
          count: entities.marches_publics.count,
          results: entities.marches_publics.items || [],
          next: null,
          previous: null
        }));
      } else {
        yield put(Actions.searchMarchesPublicsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));
      }

      // Dispatcher les succès pour les décisions de justice (parties)
      if (entities?.parties && entities.parties.items && entities.parties.items.length > 0) {
        // Séparer les parties par rôle et créer les décisions
        const demandeurs = [];
        const defendeurs = [];

        entities.parties.items.forEach(partie => {
          if (partie.decisions_info && partie.decisions_info.length > 0) {
            partie.decisions_info.forEach(decision => {
              const decisionItem = {
                decision_id: decision.decision_id,
                date_decision: decision.date_emission,
                reference: decision.reference,
                type_procedure: decision.type_procedure,
                tribunal: decision.tribunal,
                resume: decision.resume,
                url_doc: null,
              };

              // Déterminer si c'est un demandeur ou défendeur
              if (partie.role === 'appelant' || partie.role === 'demandeur') {
                demandeurs.push({
                  ...decisionItem,
                  defendeurs: decision.parties_adverses?.join(', ') || ''
                });
              } else if (partie.role === 'appelé' || partie.role === 'defendeur') {
                defendeurs.push({
                  ...decisionItem,
                  demandeurs: decision.parties_adverses?.join(', ') || ''
                });
              }
            });
          }
        });

        // Dispatcher les décisions pour demandeurs
        yield put(Actions.searchDecisionApplicantsSuccess({
          count: demandeurs.length,
          results: demandeurs,
          next: null,
          previous: null
        }));

        // Dispatcher les décisions pour défendeurs
        yield put(Actions.searchDecisionDefendantsSuccess({
          count: defendeurs.length,
          results: defendeurs,
          next: null,
          previous: null
        }));

        // Dispatcher les autres décisions (vides pour le moment, car pas de distinction dans la nouvelle API)
        yield put(Actions.searchOthersApplicantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchOthersDefendantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

      } else {
        // Pas de décisions, dispatcher des résultats vides
        yield put(Actions.searchDecisionApplicantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchDecisionDefendantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchOthersApplicantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));

        yield put(Actions.searchOthersDefendantsSuccess({
          count: 0,
          results: [],
          next: null,
          previous: null
        }));
      }

      // Dispatcher le succès global
      yield put(Actions.fetchCompanyEntitiesSuccess(response?.data));

    } else {
      yield call(toast.error, "Une erreur s'est produite lors de la récupération des données.");
      yield put(Actions.fetchCompanyEntitiesFailed(response.error));
    }
  } catch (e) {
    const is429Error = e?.response?.status === 429;
    const isRateLimitError = e?.response?.data?.message === "Limite de requêtes atteinte.";

    if (is429Error || isRateLimitError) {
      yield call(toast.error, "Vous avez atteint la limite de recherche gratuite. Veuillez vous connecter et recharger votre compte pour continuer vos recherches.");
    } else {
      yield call(toast.error, "Une erreur s'est produite lors de la récupération des données.");
    }

    yield put(Actions.fetchCompanyEntitiesFailed(e));
  }
}

export default function* searchSaga() {
  // Nouvelle saga pour vérifier le crédit avant la recherche
  yield takeEvery(
    Constants.CHECK_CREDIT_REQUESTING,
    checkCreditAndSearchSaga,
  );

  yield takeEvery(
    Constants.SEARCH_REQUESTING,
    loadSearchSaga,
  );

  yield takeEvery(
    Constants.SEARCH_REQUESTING_ALERTE,
    loadSearchAlerteSaga,
  );

  yield takeEvery(
    Constants.SEARCH_DETAIL_REQUESTING,
    loadSearchDetailSaga,
  );

  yield takeEvery(
    Constants.SEARCH_DECISION_APPLICANTS_REQUESTING,
    loadSearchDecisionApplicantsSaga,
  );
  yield takeEvery(
    Constants.PAGINATE_SEARCH_DECISION_APPLICANTS_REQUESTING,
    loadPaginateSearchDecisionApplicantsSaga,
  );

  yield takeEvery(
    Constants.SEARCH_DECISION_APPLICANTS_REQUESTING,
    loadSearchDecisionDefendantsSaga,
  );
  yield takeEvery(
    Constants.PAGINATE_SEARCH_DECISION_APPLICANTS_REQUESTING,
    loadPaginateSearchDecisionDefendantsSaga,
  );

  yield takeEvery(
    Constants.SEARCH_OTHERS_APPLICANTS_REQUESTING,
    loadSearchOthersApplicantsSaga,
  );
  yield takeEvery(
    Constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_REQUESTING,
    loadPaginateSearchOthersApplicantsSaga,
  );

  yield takeEvery(
    Constants.SEARCH_OTHERS_DEFENDANTS_REQUESTING,
    loadSearchOthersDefendantsSaga,
  );
  yield takeEvery(
    Constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_REQUESTING,
    loadPaginateSearchOthersDefendantsSaga,
  );

  yield takeEvery(
    Constants.SEARCH_DETAIL_DIRIGEANTS_REQUESTING,
    loadSearchDirigeantsDetailSaga,
  );

  yield takeEvery(
    Constants.SEARCH_ANNONCES_REQUESTING,
    loadSearchAnnoncesSaga,
  );

  yield takeEvery(
    Constants.SEARCH_MARCHES_PUBLICS_REQUESTING,
    loadSearchMarchesPublicsSaga,
  );

  yield takeEvery(
    Constants.PAGINATE_SEARCH_ANNONCES_REQUESTING,
    loadPaginateSearchAnnoncesSaga,
  );

  yield takeEvery(
    Constants.PAGINATE_SEARCH_MARCHES_PUBLICS_REQUESTING,
    loadPaginateSearchMarchesPublicsSaga,
  );

  // Nouvelle saga pour récupérer toutes les entités en un seul appel
  yield takeEvery(
    Constants.FETCH_COMPANY_ENTITIES_REQUESTING,
    loadCompanyEntitiesSaga,
  );
}